import React, { useEffect, useState } from 'react'
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr } from '../../../../components/styles/table-style'
import axios from 'axios'
import lookup from '../../../../assets/certificates/Tables/lookup.svg'
import { useNavigate } from 'react-router-dom'

interface Resource {
  id: number
  name: string
  type: string
  category: string
  pricePerUnit: string
  description: string
  suppliers: {
    id: number
    name: string
    cnpj: string
  }[]
}

const ResourcesTable:React.FC = () => {
  const [resources, setResources] = useState<Resource[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    const getResources = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_RESOURCES_BASE_URL}/resource`)
        if(response.data) setResources(response.data)
      } catch (error) {
        console.error(error)
      }
    }
    getResources()
  }, [])
  
  return (
    <GlobalTable>
        <thead>
          <HeaderLine>
            <Th>Código</Th>
            <Th>Insumo</Th>
            <Th>Tipo</Th>
            <Th>Categoria</Th>
            <Th>Preço/un</Th>
            <Th>Fornecedores</Th>
            <Th>Descrição</Th>
            <Th></Th>
          </HeaderLine>
        </thead>
        <tbody>
          {resources.map((resource, index) => (
            <Tr key={index}>
              <Td>{resource.id}</Td>
              <Td>{resource.name}</Td>
              <Td>{resource.type}</Td>
              <Td>{resource.category}</Td>
              <Td>R${resource.pricePerUnit.replace('.', ',')}</Td>
              <Td>
                {resource.suppliers?.length > 0 
                  ? resource.suppliers.map(s => s.name).join(', ')
                  : 'Nenhum fornecedor'
                }
              </Td>
              <Td>{resource.description}</Td>
              <TdButtons>
                <img src={lookup} alt='lookup' onClick={() => navigate(`view/?id=${resource.id}`)} />
              </TdButtons>
            </Tr>
          ))}
        </tbody>
      </GlobalTable>
    )
}

export default ResourcesTable